// @flow

import type { AppService } from 'app/developer-v3/types';

const createFieldChoiceFromService = ({ key, display }: AppService) => ({
  value: key,
  label: display.label,
});

export { createFieldChoiceFromService };
